/**
 * This makes a request to get the
 *  actual logo component from the
 *  project's 'components' directory.
 */

function loadLogo() {
  fetch("./components/logo.html", { method: "GET" }).then((response) =>
    response.text().then(updateLogoElements)
  );
}

function updateLogoElements(logoData) {
  const logoElements = document.querySelectorAll(".logo");
  Array.from(logoElements).forEach((logo) => (logo.innerHTML = logoData));
}

loadLogo();
